export const REQUEST_PRODUCT = "REQUEST_PRODUCT";
export const RECEIVE_PRODUCT = "RECEIVE_PRODUCT";

const actions = {
  getProduct(payload) {
    return { type: REQUEST_PRODUCT, payload };
  }
};

export default actions;
